import createMediaQuery from '../../common/js/mediaQuery.js';


function render(rootDom) {
    const $root = $(rootDom);
    const $slides = $root.children();
    const $pageWrapper = $root.closest('.page__wrapper');
    const $footerPrev = $('<div class="aq-protect-prev aq-protect-prev--footer js-aq-protect-prev"></div>');
    const mobileMediaQuery = createMediaQuery('(max-width: 767px)');
    const touchMediaQuery = createMediaQuery('(pointer: coarse)');

    const scrollUpEventName = touchMediaQuery.isTrue() ? 'swiped-down' : 'wheelup';
    const scrollDownEventName = touchMediaQuery.isTrue() ? 'swiped-up' : 'wheeldown';

    const $html = $('html');
    const $win = $(window);
    let animating = false;
    let isPageEnd = false;
    let $activeSlide = $slides.eq(0);
    let footerHeight = $pageWrapper.height() - document.documentElement.clientHeight;


    $footerPrev.insertAfter($root);

    $win
        .on('wheel', function(event){
            if(event.originalEvent.deltaY !== 0){
                if(event.originalEvent.deltaY < 0){
                    $win.trigger('wheelup');
                }
                else {
                    $win.trigger('wheeldown');
                }
            }
        })
        .on('resized', function(){
            footerHeight = $pageWrapper.height() - document.documentElement.clientHeight;
        });

    $('.js-aq-protect-prev').on('click', wheelUp);
    $('.js-aq-protect-next').on('click', wheelDown);


    function initScroll() {
        $('html, body').scrollTop(0);
        $html.addClass('_aqualor-protect');
        $activeSlide = $slides.eq(0);
        $activeSlide
            .addClass('_active')
            .next()
            .addClass('_next');
        $win.on(scrollDownEventName, wheelDown);
        $win.on(scrollUpEventName, wheelUp);

        setTimeout(() => {
            $root.addClass('_ready');
            setTimeout(() => {
                $win.trigger('slide:ready');
            }, 10);
        }, 10);
    }

    function destroyScroll() {
        $html.removeClass('_aqualor-protect');
        $root.removeClass('_ready');
        $slides.removeClass('_active _prev _next');
        $pageWrapper.css('transform', '');

        $win.off(scrollDownEventName, wheelDown);
        $win.off(scrollUpEventName, wheelUp);
    }


    mobileMediaQuery.onTrue(() => {
        destroyScroll();
    });

    mobileMediaQuery.onFalse(() => {
        initScroll();
    });

    mobileMediaQuery.change();


    function wheelDown() {
        if (!animating) {
            animating = true;

            scrollNext();

            setTimeout(() => {
                animating = false;
            }, 1000);

            setTimeout(() => {
                $win.trigger('slide:ready');
                $win.trigger('slide:change');
            }, 500);
        }
    }

    function wheelUp() {
        if (!animating) {
            animating = true;

            scrollPrev();

            setTimeout(() => {
                animating = false;
            }, 1000);

            setTimeout(() => {
                $win.trigger('slide:ready');
                $win.trigger('slide:change');
            }, 500);
        }
    }

    function scrollNext() {
        const $next = $activeSlide.next();

        if ($next.length) {
            $slides.removeClass('_active _prev _next');
            $activeSlide = $next;
            $activeSlide
                .addClass('_active')
                .next()
                .addClass('_next');
            $activeSlide
                .prev()
                .addClass('_prev');
        } else {
            isPageEnd = true;
            $pageWrapper.css('transform', `translateY(-${footerHeight}px)`);
            $footerPrev.css('transform', `translateY(${footerHeight}px) rotate(180deg)`);
            $root.addClass('_atFooter');
        }
    }

    function scrollPrev() {
        const $prev = $activeSlide.prev();

        if ($prev.length && !isPageEnd) {
            $slides.removeClass('_active _prev _next');
            $activeSlide = $prev;
            $activeSlide
                .addClass('_active')
                .next()
                .addClass('_next');
            $activeSlide
                .prev()
                .addClass('_prev');
        } else {
            isPageEnd = false;
            $pageWrapper.css('transform', '');
            $footerPrev.css('transform', '');
            $root.removeClass('_atFooter');
        }
    }
}


document.querySelectorAll('.js-page-aqualor-protect').forEach(render);



// WEBPACK FOOTER //
// ./_src/components/pageScroll/index.js